import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Project } from '../classes/project.class';
import { User } from '../classes/user.class';
import { CodaltComponent } from '../codalt.component';

export interface ExecutorProjectChoiceDialogData {
    entryCount: number;
    sourceExecutor: User;
    sourceProject: Project;
}

export interface ExecutorProjectChoiceDialogResult {
    choice: 'executor' | 'project';
}

@Component({
    selector: 'app-executor-project-choice-dialog',
    templateUrl: './executor-project-choice-dialog.component.html',
    styleUrl: './executor-project-choice-dialog.component.scss',
    standalone: false,
})
export class ExecutorProjectChoiceDialogComponent extends CodaltComponent {
    constructor(
        private dialogRef: MatDialogRef<ExecutorProjectChoiceDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ExecutorProjectChoiceDialogData
    ) {
        super();
    }

    get message(): string {
        const entryCount = this.data.entryCount;
        return `Wat wil je wijzigen voor de ${entryCount} planning${entryCount === 1 ? '' : 'en'} van ${this.data.sourceExecutor.name} op project ${this.data.sourceProject.afas_project_id}?`;
    }

    onExecutorChoice(): void {
        const result: ExecutorProjectChoiceDialogResult = {
            choice: 'executor',
        };
        this.dialogRef.close(result);
    }

    onProjectChoice(): void {
        const result: ExecutorProjectChoiceDialogResult = {
            choice: 'project',
        };
        this.dialogRef.close(result);
    }

    onCancel(): void {
        this.dialogRef.close();
    }
}
